/* eslint-disable */
import React, { Component } from 'react';
import { Grid, Header, Image, Segment } from 'semantic-ui-react';

const worksWith=require('../../img/BeemaWorksWith.svg');

class TargetClients extends Component {
  render() {
    return (
      <div>
        <Segment style={{ padding: '8em 0em', backgroundColor:'#E94A7E' }} vertical>
          <Grid container stackable>
            <Grid.Row>
              <Grid.Column width={16}>
                 <Header as='h3' style={{ fontSize: '2.5em', fontFamiy: 'Raleway', fontFamily: 'serif'}}> We specialize in helping... </Header>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row centered>
              <Grid.Column width={2}></Grid.Column>
              <Grid.Column width={14} centered='true'>
                <Image style={{padding: '4em 0em 0em 0em'}} centered href='/home#request-acesss' centered src={worksWith} size='massive' title='our target clients are freelancers, small business owners, and millennial founders'/>
              </Grid.Column>
              <Grid.Column width={1}></Grid.Column>
            </Grid.Row>
          </Grid>
        </Segment>
      </div>
    );
  }
};

export default TargetClients;



// WEBPACK FOOTER //
// ./src/js/Home/TargetClients.js